import React, { useEffect, useState } from 'react'
import { tokenApi } from '../../common/api'

const PERIODS = [
  { key: 'last_24h', label: '24h' },
  { key: 'last_7d',  label: '7d' },
  { key: 'last_30d', label: '30d' },
  { key: 'total',    label: 'Kaikki' },
]

export default function TabStats({ token, widgetId, t }) {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    tokenApi
      .get(token, `/dashboard/widget/${widgetId}/stats`)
      .then(res => { if (res.data.success) setStats(res.data.stats) })
      .finally(() => setLoading(false))
  }, [widgetId])

  if (loading) return <div className="loader loader--box"><i className="fas fa-spin fa-spinner" /></div>

  const rows = [
    { label: t('widget.statsImpressions') || 'Impressiot', data: stats && stats.impressions },
    { label: t('widget.statsVideoPlays') || 'Videoiden toistot', data: stats && stats.videoPlays },
  ]

  return (
    <table className="widget-stats-table">
      <thead>
        <tr>
          <th></th>
          {PERIODS.map(p => <th key={p.key}>{p.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr key={row.label}>
            <td className="widget-stats-table-label">{row.label}</td>
            {PERIODS.map(p => (
              <td key={p.key} className="widget-stats-table-value">
                {row.data ? row.data[p.key] : '—'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
